import { render, staticRenderFns } from "./epaperList.vue?vue&type=template&id=466ed4b9&"
import script from "./epaperList.vue?vue&type=script&lang=js&"
export * from "./epaperList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports